import React from 'react';

import { Spin, Table, Tooltip } from 'antd';

import MyIcon from 'components/Icon';
import Truncate from 'components/Truncate';
import { enums } from 'helpers';
import { PRODUCT_STATUS_LABEL } from 'helpers/enums';
import ProductStatusTag from 'scenes/Producer/Product/MyProducts/components/ProductStatusTag';
import { TableActionButton } from 'v2/components/Shared/TableActionButton';
import { useProductVariations } from 'v2/hooks/useProductVariations';
import type { IProduct } from 'v2/interfaces/product';

import ShowPrice from '../ShowPrice';

type DataChildrenProps = {
  product: IProduct;
  onClickOptions: (product: IProduct, activatedChildren: number) => void;
};

const DataChildren = ({ product, onClickOptions }: DataChildrenProps) => {
  const productVariationsQuery = useProductVariations(product.id, {
    enabled: true
  });

  const columns = [
    {
      title: 'Produto',
      key: 'product',
      render: (_: any, variation: any) => (
        <div className='flex items-start gap-3'>
          <div
            className='border-grey-100 bg-grey-100 h-10 w-10 shrink-0 rounded-sm border bg-cover bg-center bg-no-repeat'
            style={{ backgroundImage: `url(${variation.image})` }}
          />
          <div className='basic'>
            <div className='title' title={variation.title || 'Desconhecido'}>
              <Truncate count={80} final='...'>
                {variation.title || 'Desconhecido'}
              </Truncate>
            </div>
            {!variation.has_children && (
              <div
                style={{ marginTop: '5px' }}
                className={`moderation__status ${
                  enums.PRODUCT_STATUS_CLASS[variation.moderation_status as keyof typeof enums.PRODUCT_STATUS_CLASS] ??
                  ''
                }`}
              >
                <ProductStatusTag status={variation.moderation_status} productType={variation.type} />
                {variation.charge_type === 'A' && (
                  <Tooltip title='Recorrência' placement='top'>
                    <div className='mt-1 w-[15px] shrink-0'>
                      <MyIcon className='icon' name='icon-assinaturas' />
                    </div>
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      title: 'Status',
      key: 'status',
      align: 'center' as const,
      render: (_: any, variation: any) => (
        <span
          className={`p-3 text-center text-sm font-semibold whitespace-nowrap max-md:hidden ${
            variation.status === 'active' ? 'text-success' : 'text-text-secondary'
          }`}
        >
          {PRODUCT_STATUS_LABEL[variation.status]}
        </span>
      )
    },
    {
      title: 'Preço',
      key: 'price',
      render: (_: any, variation: any) => <ShowPrice product={variation} commission='normal' />
    },
    {
      title: '',
      key: 'actions',
      align: 'right' as const,
      render: (_: any, variation: any) => (
        <TableActionButton onClick={() => onClickOptions(variation, productVariationsQuery.data?.length)} />
      )
    }
  ];

  return (
    <div>
      {productVariationsQuery.isLoading && (
        <div className='flex justify-center py-4'>
          <Spin size='small' />
        </div>
      )}
      <Table
        className='border-border rounded border'
        size='small'
        dataSource={productVariationsQuery.data}
        columns={columns}
        rowKey='id'
        pagination={false}
      />
    </div>
  );
};

export default DataChildren;
